<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 offset-xs0 md8 offset-md2>
        <v-btn to="/customers/new" fab fixed bottom right color="primary">
          <v-icon>add</v-icon>
        </v-btn>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details @change="searchCustomers()"></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="customers" :loading="customersLoading" :pagination.sync="pagination" :total-items="totalCustomers" :rows-per-page-items="rowsPerPageItems">
            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.firstName }} {{ props.item.lastName }}</td>
              <td>{{ props.item.quotes }}</td>
              <td>{{ props.item.freeSamples }}</td>
              <td>{{ props.item.orders }}</td>
              <td>
                <v-select @change="customerActions" :items="[{ text: 'View Customer', value: { action: 'view', id: props.item._id } },
                  { text: 'Delete', value: { action: 'delete', id: props.item._id }}]" label="Actions"></v-select>
              </td>
            </template>
            <template slot="no-data">
              {{ loadingText }}
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CustomerService from '@/services/CustomerService'
// import OrderService from '@/services/OrderService'
export default {
  name: 'customers',
  data () {
    return {
      customers: [],
      headers: [
        { text: 'Customer', value: 'customer' },
        { text: 'Quotes', value: 'quotes' },
        { text: 'Free Samples', value: 'freeSamples' },
        { text: 'Orders', value: 'orders' },
        { text: 'Actions', value: 'actions' }
      ],
      customersLoading: false,
      search: null,
      loadingText: 'Loading...',
      pagination: {},
      totalCustomers: 0,
      rowsPerPageItems: [10, 20, 30]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getCustomers().then(data => {
          this.customers = data
        })
      },
      deep: true
    }
  },
  methods: {
    async getCustomers () {
      this.ordersLoading = true

      const { sortBy, descending, page, rowsPerPage } = this.pagination

      const response = await CustomerService.fetchLimitedCustomers(page, rowsPerPage, this.search)

      for (var index in response.data.customers) {
        response.data.customers[index].quotes = 0
        response.data.customers[index].orders = 0
        response.data.customers[index].freeSamples = 0

        const orderResponse = await CustomerService.getOrders(response.data.customers[index]._id)
        if (orderResponse.data.success) {
          for (var i in orderResponse.data.orders) {
            if (orderResponse.data.orders[i].status === 'Quote') {
              response.data.customers[index].quotes++
            } else if (orderResponse.data.orders[i].freeSampleOrder) {
              response.data.customers[index].freeSamples++
            } else {
              response.data.customers[index].orders++
            }
          }
        }
      }

      let items = response.data.customers

      if (this.pagination.sortBy) {
        items = items.sort((a, b) => {
          const sortA = a[sortBy]
          const sortB = b[sortBy]

          if (descending) {
            if (sortA < sortB) return 1
            if (sortA > sortB) return -1
            return 0
          } else {
            if (sortA < sortB) return -1
            if (sortA > sortB) return 1
            return 0
          }
        })
      }

      const totalResponse = await CustomerService.countCustomers(this.search)
      this.totalCustomers = totalResponse.data.count

      if (this.totalOrders === 0) {
        this.loadingText = 'No customers found.'
      }

      this.customersLoading = false

      return items
    },

    async searchCustomers () {
      this.customers = await this.getCustomers()
    },

    async deleteCustomer (id) {
      const response = await CustomerService.deleteCustomer(id)

      if (response.data.success) {
        this.getCustomers()
      }
    },

    async customerActions (value) {
      switch (value.action) {
        case 'view':
          this.$router.push({ path: `/customers/${value.id}` })
          break
        case 'delete':
          this.deleteCustomer(value.id)
          this.getCustomers()
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customers/Customers.vue